

import { FC, useEffect } from 'react';

import RichText from '@eneco/components/RichText/RichText';
import { TrackedNotificationBox } from '@eneco/components/TrackedNotificationBox/TrackedNotificationBox';
import { Button, Stack } from '@eneco/sparky';
import { StackProps } from '@eneco/sparky/types';
import { NotificationField } from '@sitecore/types/AddressStep';
import { TextField } from '@sitecore-jss/sitecore-jss-react';
import { signIn } from 'next-auth/react';

interface Props extends Pick<StackProps, 'alignY'> {
  type?: 'GENERIC' | 'AUTHENTIFICATION';
  textualData: {
    notification?: NotificationField;
    buttonLabel?: TextField;
  };
}

export const SmeFlowError: FC<Props> = ({ textualData, alignY, type = 'GENERIC' }) => {
  useEffect(() => {
    if (type === 'AUTHENTIFICATION') signIn('okta');
  }, [type]);

  return (
    <>
      {textualData?.notification && (
        <TrackedNotificationBox
          label={textualData.notification.value?.title}
          title={textualData.notification.value?.title}
          isAlert
          text={<RichText html={textualData.notification.value?.content} />}
          variant={textualData.notification.value?.variant}
        />
      )}

      {textualData?.buttonLabel && type !== 'AUTHENTIFICATION' && (
        <Stack direction={{ initial: 'column', md: 'row' }} alignY={alignY}>
          <Button type="button" onClick={() => window.location.reload()}>
            {textualData.buttonLabel.value}
          </Button>
        </Stack>
      )}
    </>
  );
};
